import { SxProps } from "@mui/material";
// Note: ts-ignore is used to ignore the following error:
// "Cannot find module './images/404.svg' or its corresponding type declarations.ts(2307)"
//
// TSC is trying to resolve the svg images as TS/JS modules.
// However, we rely on webpack in the client to resolve the images
// using the appropriate loader.
// Thus, we transpile only by using @ts-ignore
//@ts-ignore
import Url404 from "./images/404.svg";
//@ts-ignore
import UrlErrorBoundarySorry from "./images/error-boundary-sorry.svg";
//@ts-ignore
import UrlFiles from "./images/files.svg";
import { LxImg } from "./LxImg";

interface ImgProps {
  sx?: SxProps;
}

/**
 * A 404 image
 *
 * @package Media
 * @example
   <LxImgNotFound sx={{p: 2}} />
 */
export function LxImgNotFound(props: ImgProps) {
  return (
    <LxImg
      src={Url404}
      alt="404 not found"
      width={832 / 8}
      height={254 / 8}
      {...props}
    />
  );
}

/**
 * A sorry image.
 *
 * @package Media
 * @example
   <LxImgSorry sx={{p: 2}} />
 */
export function LxImgSorry(props: ImgProps) {
  return (
    <LxImg
      src={UrlErrorBoundarySorry}
      alt="sorry"
      width={380 / 8}
      height={249 / 8}
      {...props}
    />
  );
}

/**
 * A image that shows some 'files'.
 *
 * @package Media
 * @example
   <LxImgFiles sx={{p: 2}} />
 */
export function LxImgFiles(props: ImgProps) {
  return (
    <LxImg
      src={UrlFiles}
      alt="files"
      width={122 / 8}
      height={130 / 8}
      {...props}
    />
  );
}
